// extracted by mini-css-extract-plugin
export default {"link":"OJ-z","disabled":"PJ-z"};